// extracted by mini-css-extract-plugin
export default {"this":"Foot_this__qkDED","lang":"Foot_lang__7gYS3","selected":"Foot_selected__RWb3x","links":"Foot_links__mjjrL"};